import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import serviceTypeService from '../../services/serviceTypeService';

export const useNewToken = () => {
	const [errorMessage, setErrorMessage] = useState('');
	const [loading, setLoading] = useState(false);
	const [serviceTypes, setServiceTypes] = useState([]);

	const navigate = useNavigate();

	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await serviceTypeService.getAllActive();
			const items = Array.isArray(response?.data) ? response.data : [];
			setServiceTypes(items);
			setErrorMessage('');
		} catch (e) {
			console.error('Failed to fetch service types', e);
			setErrorMessage('Не удалось загрузить типы услуг');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		serviceTypes,
		loading,
		errorMessage,
		navigate
	};
};
